/**
 * Expects global vars below to be populated prior to script being rendered on page
 * elevarPageType (Type of page. Example product, collection, checkout, article, etc.)
 * elevarPageTitle (The title of the page being viewed)
 */


document.addEventListener('DOMContentLoaded', (e) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'bp_pageview_setup',
    bp_page_type: elevarPageType,
    bp_page_title: elevarPageTitle
  });

  (function() {
    if (!elevarPageType) elevarPageType = 'checkout'
    var pageType = elevarPageType.toLowerCase();
    const events = [] // Array to hold the list of promotions viewed
    const clickEvents = []
    let loadCount = 0 // How many times have we added groups of events
    let sendCount = 2 // How many times total we will add events before we send them
    const sortEvents = function(unsorted) {
      unsorted.sort((a, b) => {
        if(a.ref === b.ref) return 0
        if(!a.ref.compareDocumentPosition) {
          // old browsers
          return a.ref.sourceIndex - b.ref.sourceIndex;
        }
        if(a.ref.compareDocumentPosition(b.ref) & Node.DOCUMENT_POSITION_PRECEDING) {
          // b comes before a
          return 1;
        }
        // b comes after a
        return -1;
      })
      return unsorted.map((item, index) => {
        return item
      })
    }
    const sendElevarEvents = function(events) {
      events = events.filter(e => e.promotion_id !== undefined && e.creative_slot !== undefined)
      if(events.length > 0) {
        console.log('sending view_promotion events', events)
        window.dataLayer.push({ecommerce: null})
        window.dataLayer.push({
          event: 'view_promotion',
          ecommerce: {
            items: events
          }
        })
      }
    }
    const commitEvents = function() {
      loadCount++
      if(loadCount >= sendCount) {
        sendElevarEvents(sortEvents(events))
      }
    }
    const navEvents = function() {
      const features = document.querySelectorAll('.menu__group--feature'),
            visibleNode = document.createElement('div'),
            visibleNodes = []
      visibleNode.classList.add('menu__group-elevar-tracking')

      if(features.length > 0) {
        features.forEach(el => {
          const newNode = visibleNode.cloneNode()
          visibleNodes.push(newNode)
          el.prepend(newNode)
        })
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // If the entry is already tracked, don't do it again
          const parent = entry.target.parentElement
          if(entry.target.dataset.tracked === undefined) {
            if(entry.isIntersecting) {
              // Set that the element is visbile
              entry.target.dataset.intersecting = 'true'
              // Element must be visible for 0.75s to be "viewed"
              setTimeout(() => {
                // If the item is still visible, send promotion
                if(entry.target.dataset.intersecting === 'true') {
                  entry.target.dataset.tracked = 'true'
                  var navPromoName = parent.querySelector('.menu__title').textContent.trim();
                  if(navPromoName){
                    var navPromoId = idHandle(navPromoName)
                  };
                  const event = {
                    promotion_id: navPromoId,
                    promotion_name: navPromoName,
                    creative_slot: `nav-${parent.closest('.menu').getAttribute('id')}`,
                    location_id: 'main-nav_'+pageType
                  }
                  sendElevarEvents([event])
                  sendSelectPromotion(parent, event)
                }
              }, 750)
            } else {
              // Set that the item is no longer visible
              entry.target.dataset.intersecting = 'false'
            }
          }
        })
      })
      console.log('VisibleNodes', visibleNodes)
      visibleNodes.forEach(element => observer.observe(element))
    }
    const idHandle = function(str) {
      str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/([^\w]+|\s+)/g, '-')
        .replace(/\-\-+/g, '-')
        .replace(/(^-+|-+$)/g, '')
        .toLowerCase();
      return str
    };

    // Take a slick slider element and return the product info from the currently visible slides
    const nostoSliderItems = function(sliderEl) {
      const slides = sliderEl.querySelectorAll('.slick-list .slick-active')
      const items = []
      slides.forEach(slide => {
        items.push({
          item_id: slide.querySelector('[data-product-sku]')?.dataset.productSku || slide.querySelector('[data-product-id]')?.dataset.productId,
          item_name: slide.querySelector('[data-product-title]')?.dataset.productTitle,
          id: slide.querySelector('[data-product-id]')?.dataset.productSku,
          name: slide.querySelector('[data-product-title]')?.dataset.productTitle,
          price: slide.querySelector('[data-product-price]')?.dataset.productPrice.replace('$', ''),
          product_id: slide.querySelector('[data-product-id]')?.dataset.productId,
          variant_id: slide.querySelector('[data-variant-id]')?.dataset.variantId,
          compare_at_price: slide.querySelector('[data-product-msrp-price]')?.dataset.productMsrpPrice.replace('$', ''),
          slide: slide
        })
      })
      return items
    }

    const buildEventFromElement = function(el) {
      const promoName = el.getAttribute('data-promo-name')
      const promoId = idHandle(promoName ? promoName : '')
      return {
        promotion_id: promoId,
        promotion_name: promoName,
        creative_slot: el.getAttribute('data-promo-slot'),
        location_id: `shopify_${pageType}`
      }
    }

    navEvents()
    document.querySelectorAll('[data-promo-slot]').forEach(el => {
      const event = buildEventFromElement(el)
      events.push(event)
      clickEvents.push({
        el: el,
        event: event
      })
    })

    // Track dragging sliders to ensure we don't send a click on a swipe
    let dragging = false
    $(document).on('beforeChange', () => dragging=true)
    $(document).on('afterChange', () => dragging=false)

    const sendSelectPromotion = function(parent, event) {
      if(event === undefined) {
        event = buildEventFromElement(parent)
      }
      parent.querySelectorAll('a[href^="/"],a[href^="https"]').forEach(el => {
        // If the element already has a class then we don't need to watch it again
        if(el.classList.contains('select_promotion')) {
          return
        }
        // Add the class so we don't process it twice
        el.classList.add('select_promotion')
        let prevent = true
        el.addEventListener('click', e => {
          if(dragging) {
            return
          }
          if(prevent) {
            // Stop link from navigating and send it to datalayer
            e.preventDefault()
            prevent = false
            console.log('Sending select_promotion events', event)
            window.dataLayer.push({ecommerce: null})
            window.dataLayer.push({
              event: 'select_promotion',
              ecommerce: {
                items: [event]
              }
            })
            this.setTimeout(() => {
              // Reclick the same link 250ms later now that we won't prevent it from navigating
              el.click()
            }, 250)
          }
          // Link will navigate to url
        })
      })
    }

    commitEvents()
    window.addEventListener('load', function(e) {
      if (!window.nosto) {
        sendCount = 1
        commitEvents()
      } else {
        if (typeof nostojs === 'undefined') return;
        nostojs(function(api) {
          api.listen('postrender', function(event) {
            event.filledElements.forEach(name => {
              const nostoElement = document.getElementById(name)
              const nostoPromoNameEl = nostoElement.querySelector('[data-promo-name]')
              const nostoPromoName = nostoPromoNameEl.dataset.promoName ? nostoPromoNameEl.dataset.promoName : null
              const nostoSlider = nostoElement.querySelector('.slick-slider')
              if(nostoPromoName){
                var nostoPromoID = idHandle(nostoPromoName)
              };

              // If there is a product slider then send one event for each item shown on the first page of the carousel
              if(nostoSlider && nostoSlider.querySelectorAll('.product-card').length > 0) {
                const nostoItems = nostoSliderItems(nostoSlider)
                nostoItems.forEach(item => {
                  const event = {
                    promotion_id: nostoPromoID,
                    promotion_name: nostoPromoName,
                    creative_slot: name,
                    location_id: 'nosto_'+pageType,
                    id: item.id,
                    name: item.name,
                    brand: 'Bulletproof',
                    price: item.price,
                    product_id: item.product_id,
                    compare_at_price: item.compare_at_price === item.price ? null : item.compare_at_price, // only provide value if compare_at_price is different
                    item_id: item.item_id,
                    item_name: item.item_name,
                  }
                  events.push(event)
                  clickEvents.push({
                    el: item.slide,
                    event: event
                  })
                })
                // Add an event to send more view_promotions when a different page of the slider is viewed
                $(nostoSlider).on('afterChange', () => {
                  const items = nostoSliderItems(nostoSlider)
                  const sliderEvents = []
                  items.forEach(item => {
                    const event = {
                      promotion_id: nostoPromoID,
                      promotion_name: nostoPromoName,
                      creative_slot: name,
                      location_id: 'nosto_'+pageType,
                      id: item.id,
                      name: item.name,
                      brand: 'Bulletproof',
                      price: item.price,
                      product_id: item.product_id,
                      compare_at_price: item.compare_at_price === item.price ? null : item.compare_at_price, // only provide value if compare_at_price is different
                      item_id: item.item_id,
                      item_name: item.item_name,
                    }
                    sliderEvents.push(event)
                    clickEvents.push({
                      el: item.slide,
                      event: event
                    })
                  })
                  sendElevarEvents(sliderEvents)
                })

              } else {
                const event = {
                  promotion_id: nostoPromoID,
                  promotion_name: nostoPromoName,
                  creative_slot: name,
                  location_id: 'nosto_'+pageType
                }
                events.push(event)
                clickEvents.push({
                  el: nostoElement,
                  event: event
                })
              }
            })
            commitEvents()
          });
        });
      }
      // Handle link tracking for select_promotion
      clickEvents.forEach(click => {
        sendSelectPromotion(click.el, click.event)
      })
      // Check if there were any others that were missed on page load
      setTimeout(() => {
        this.document.querySelectorAll('[data-promo-name]').forEach(el => {
          sendSelectPromotion(el)
        })
      }, 1500)
    })
  })()
})
